.sliderContainer {
  display: flex;
  align-items: center;
  width: 100%;
  max-width: 310px;
  min-width: 0;
  box-sizing: border-box;
  gap: 10px;
  /*justify-content: space-between;*/
}

.valueInput {
  display: flex;
  align-items: center;
  flex: 0 1 9ch;
  gap: 5px;
}

.valueInput:focus {
  outline: none;
  border-bottom: 1px solid #333;
}

.slider {
  -webkit-appearance: none;
  flex: 1 1 auto; /* flex item that can shrink and grow */
  width: 100%; /* take all leftover space between the thumbs/input */
  min-width: 0;
  /*max-width: 220px;*/
  height: 3px;
  background: #e3e3e3;
  border-radius: 20px;
  corner-shape: superellipse(1.18);
  outline: none;
  transition: opacity 0.2s;
  box-sizing: border-box;
}

.slider::-webkit-slider-thumb {
  -webkit-appearance: none;
  appearance: none;
  width: 16px;
  height: 16px;
  background: #777777;
  border-radius: 50%;
  cursor: grabbing;
  box-shadow:
    rgba(0, 0, 0, 0.12) 0px 1px 3px,
    rgba(0, 0, 0, 0.24) 0px 1px 2px;
}

.slider::-moz-range-thumb {
  width: 16px;
  height: 16px;
  background: #777777;
  border-radius: 50%;
  cursor: pointer;
  box-shadow:
    rgba(0, 0, 0, 0.12) 0px 1px 3px,
    rgba(0, 0, 0, 0.24) 0px 1px 2px;
}

@media (max-width: 480px) {
  .valueInput {
    flex: 0 1 8ch;
  }
  .sliderContainer {
    flex: 1;
    gap: 8px;
    min-width: 0;
  }
  .slider {
    flex: 1;
    min-width: 100px;
  }
}

@media (max-width: 350px) {
  .sliderContainer {
    gap: 5px;
  }
  .slider {
    min-width: 60px;
  }
}
